import api from './axios';

export const listar          = ()      => api.get('/estoque/');
export const listarLancamentos = (id_modelo) => api.get('/estoque/lancamentos/', { params: { id_modelo } });
export const buscar          = (id, idTamanhoUniforme) => api.get(`/estoque/${id}/${idTamanhoUniforme}`);
export const lancarEntrada   = (data)  => api.post('/estoque/lancamento', data);
